import { Outlet } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import Navbar from '../components/navbar';
import Footer from '../components/footer/Footer';
import ChatNotificationAlert from '../components/chatNotificationAlert';

const Layout = ({ userClient }) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
            <Navbar userClient={userClient} />
            <Outlet />
            <Footer />
            {isAuthenticated && <ChatNotificationAlert />}
        </>
    );
};

export default Layout;
